// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/meeting/camera.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/dots-burger.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/ava1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/chevron-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/collapser/left.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/collapser/right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/collapser/both.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meetingPage{
    /*padding: 24px;*/
    padding: 24px 9px;
    padding-bottom: 8px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

.meetingPage_header{
    border-bottom: 1px solid rgba(152, 159, 201, 0.12);
    margin-bottom: 4px;
    display: flex;
    gap: 22px;
    padding: 16px 18px;
    align-items: center;
}

.meetingPage_header_session{
    display: flex;
    gap: 22px;
}

.meetingPage_header_logo{
    width: 35px;
    height: 20px;
    flex-shrink: 0;
    background-color: #FAFAFB;

    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.meetingPage_title{
    display: flex;
    flex-direction: column;
}

.meetingPage_title_text{
    font-weight: 400;
    font-size: 24px;
    line-height: 22px;
    color: #000000;
    margin-bottom: 12px;
}

.meetingPage_title_date{
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #CAC4D0;
}

.meetingPage_header_left{
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*width: calc(100% / 4 * 3);*/
    width: 100%;
}

.meetingPage_burger{
    width: 41px;
    height: 41px;
    flex-shrink: 0;

    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.meetingPage_client{
    display: flex;
    gap: 24px;
    align-items: center;
    /*width: calc(100% / 4 * 1);*/
    min-width: max-content;
    flex-shrink: 0;
}

.meetingPage_client_avatar{
    width: 66px;
    height: 66px;
    border-radius: 100%;
    flex-shrink: 0;
    background-color: #0009;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.meetingPage_client_info{
    display: flex;
    flex-direction: column;
    gap: 0px;
}

.meetingPage_client_name{
    font-weight: 400;
    font-size: 24px;
    line-height: 33px;

    color: #08080A;
}

.meetingPage_client_profile{
    font-style: italic;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #8E9ABB;
}

.meetingPage_center{
    display: flex;
    align-items: flex-start;
    /*gap: 17px;*/

    position: relative;
    height: 100%;
    overflow: hidden;
}

.meetingPage_video{
    display: flex;
    flex-direction: column;
    width: 100%;
    /*gap: 19px;*/
    height: 100%;
    padding: 16px 9px;
}

.meetingPage_chat{
    width: 100%;
    --gap: 40px;
    gap: var(--gap);
    display: flex;
    /*flex-direction: column;*/
    /*align-items: center;*/

    flex-wrap: wrap;
    --cols: 1;
}

.meetingPage_bottom{
    display: flex;
    padding: 22px 0px;
    gap: 17px;
}

.meetingPage_wordTimes{
    display: flex;
    align-items: flex-start;
}

.meetingPage_widgets{
    overflow-x: hidden;
    overflow-y: auto;
    /*width: 320px;*/
    flex-shrink: 0;
    height: 100%;
    padding: 16px 9px;
    scrollbar-width: thin; /* Firefox */
    scrollbar-color: transparent transparent; /* Firefox */
}

.meetingPage_widgets::-webkit-scrollbar {
    width: 8px;
}

.meetingPage_widgets::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
    margin: 4px 0;
}

.meetingPage_widgets::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
    transition: background-color 0.3s ease;
}

.meetingPage_widgets:hover {
    scrollbar-color: rgba(193, 193, 193, 0.8) rgba(241, 241, 241, 0.8); /* Firefox */
}

.meetingPage_widgets:hover::-webkit-scrollbar-track {
    background: rgba(241, 241, 241, 0.8);
}

.meetingPage_widgets:hover::-webkit-scrollbar-thumb {
    background: rgba(193, 193, 193, 0.8);
}

.meetingPage_widgets:hover::-webkit-scrollbar-thumb:hover {
    background: rgba(168, 168, 168, 0.9);
}

/*collapser*/
.meetingPage_video_collapser{
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    transition-duration: 400ms;
    transition-delay: 0ms;
    --phaseDelay: 400ms;
}

.meetingPage_video{
    width: 100%;
    height: 100%;
    position: absolute;
    transition-duration: 400ms;
    transition-delay: var(--phaseDelay);
    left: 0%;
}

.meetingPage_video_collapser--collapsed{
    width: 60px;
    transition-delay: var(--phaseDelay);
    overflow: hidden;
    flex-shrink: 0;
}

.meetingPage_video_collapser--collapsed .meetingPage_video{
    left: calc(-100% - 10px);
    transition-delay: 0ms;
}

.meetingPage_widgets{
    --phaseDelay: 400ms;
    transition-duration: 400ms;
    /*transition-delay: calc(var(--phaseDelay));*/
}

.meetingPage_widgets--collapsed{
    flex-shrink: 1;
    width: 100%;
    transition-delay: 0ms;
    transition-delay: calc(var(--phaseDelay));
}

.meetingPage_video_collapser_hold_zero{
    flex-shrink: 0;
    position: absolute;
    left: 100%;
    height: 100%;
    overflow: hidden;
    width: 0px;
    transition: left 400ms, width 50ms;
    /*transition-delay: calc(var(--phaseDelay));*/
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
}
.meetingPage_video_collapser_hold{
    position: absolute;
    left: 100%;
    overflow: hidden;
    width: 60px;
    display: flex;
    justify-content: center;
    height: 100%;
    padding: 16px 9px;
}

.meetingPage_video_collapse_button{
    position: absolute;
    right: 6px;
    background-color: #fff;
    width: 18px;
    height: 18px;
    border: 1px solid #ddd;
    border-radius: 100%;
    z-index: 1;
    font-size: 0;

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
    background-repeat: no-repeat;
}

.meetingPage_video_collapse_button_right{
    right: unset;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.meetingPage_video_collapser--collapsed .meetingPage_video_collapser_hold{
    left: 0px;
}

.meetingPage_video_collapser--collapsed .meetingPage_video_collapser_hold_zero{
    width: 60px;
    left: 0;
}
/**/

.meetingPage_video_subtitles_splitter{
    cursor: ns-resize;
    user-select: none; 
    font-size: 0;
    flex-shrink: 0;
    height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.meetingPage_video_subtitles_splitter::before {
    content: '';
    width: 48px;
    height: 2px;
    background-color: #d4d4d8;
    border-radius: 1px;
    transition: background-color 0.2s ease;
}

.meetingPage_video_subtitles_splitter:hover::before {
    background-color: #a1a1aa;
}

.meetingPage_bottom_graphic{
    display: flex;
    flex-direction: column;
    align-items: center;

    width: calc((100% - (var(--gap) * (var(--cols) - 1))) / var(--cols));
}

/*collapser new*/

.meetingPage_TwoColumnCollapser_wrapper{

}

.meetingPage_TwoColumnCollapser_wrapper--both .meetingPage_TwoColumnCollapser_right{
    flex-shrink: 0;
    width: 350px;
}

.meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_TwoColumnCollapser_right{
    flex-shrink: 1;
    width: 100%;
}

.meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_chat{
    --cols: 3;
    padding-top: 10px;
    transition-delay: 400ms;
    transition-duration: 200ms;
}

@media (max-width: 1080px){
    .meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_chat{
        --cols: 2;
    }
}

@media (max-width: 700px){
    .meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_chat{
        --cols: 1;
    }
}

.meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_bottom_graphic{
    transition-delay: 400ms;
    transition-duration: 200ms;
}

.meetingPage_TwoColumnButtons{
    display: flex;
    padding: 2px 8px;
    gap: 8px;
    position: absolute;
    top: -2px;
    z-index: 1;
    border-radius: 8px;
    background-color: #fff;
}

.meetingPage_TwoColumnButton{
    border-radius: 100%;
    width: 28px;
    height: 28px;
    border: none;

    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 0;
}

.meetingPage_TwoColumnButton:hover {
    background-color: #0001;
}

.meetingPage_TwoColumnButton--active {
    background-color: #0002;
}

.meetingPage_TwoColumnButton_left{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.meetingPage_TwoColumnButton_right{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.meetingPage_TwoColumnButton_both{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

/**/`, "",{"version":3,"sources":["webpack://./src/pages/meetingPage/MeetingPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,yBAAyB;;IAEzB,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,yDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,yDAAqD;AACzD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,uBAAuB;;IAEvB,yDAA8C;IAC9C,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;;IAEb,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;;IAEvB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,qBAAqB,EAAE,YAAY;IACnC,wCAAwC,EAAE,YAAY;AAC1D;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,kEAAkE,EAAE,YAAY;AACpF;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,mCAAmC;IACnC,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,kCAAkC;IAClC,6CAA6C;IAC7C,aAAa;IACb,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,YAAY;;IAEZ,yDAAuD;IACvD,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,yDAAsD;AAC1D;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,OAAO;AACX;AACA,GAAG;;AAEH;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,oEAAoE;AACxE;;AAEA,gBAAgB;;AAEhB;;AAEA;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;;IAEZ,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yDAAwD;AAC5D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,yDAAwD;AAC5D;;AAEA,GAAG","sourcesContent":[".meetingPage{\n    /*padding: 24px;*/\n    padding: 24px 9px;\n    padding-bottom: 8px;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n}\n\n.meetingPage_header{\n    border-bottom: 1px solid rgba(152, 159, 201, 0.12);\n    margin-bottom: 4px;\n    display: flex;\n    gap: 22px;\n    padding: 16px 18px;\n    align-items: center;\n}\n\n.meetingPage_header_session{\n    display: flex;\n    gap: 22px;\n}\n\n.meetingPage_header_logo{\n    width: 35px;\n    height: 20px;\n    flex-shrink: 0;\n    background-color: #FAFAFB;\n\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-image: url('../../assets/meeting/camera.svg');\n}\n\n.meetingPage_title{\n    display: flex;\n    flex-direction: column;\n}\n\n.meetingPage_title_text{\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 22px;\n    color: #000000;\n    margin-bottom: 12px;\n}\n\n.meetingPage_title_date{\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 22px;\n    color: #CAC4D0;\n}\n\n.meetingPage_header_left{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /*width: calc(100% / 4 * 3);*/\n    width: 100%;\n}\n\n.meetingPage_burger{\n    width: 41px;\n    height: 41px;\n    flex-shrink: 0;\n\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-image: url('../../assets/dots-burger.svg');\n}\n\n.meetingPage_client{\n    display: flex;\n    gap: 24px;\n    align-items: center;\n    /*width: calc(100% / 4 * 1);*/\n    min-width: max-content;\n    flex-shrink: 0;\n}\n\n.meetingPage_client_avatar{\n    width: 66px;\n    height: 66px;\n    border-radius: 100%;\n    flex-shrink: 0;\n    background-color: #0009;\n\n    background-image: url('../../assets/ava1.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.meetingPage_client_info{\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n}\n\n.meetingPage_client_name{\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 33px;\n\n    color: #08080A;\n}\n\n.meetingPage_client_profile{\n    font-style: italic;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    color: #8E9ABB;\n}\n\n.meetingPage_center{\n    display: flex;\n    align-items: flex-start;\n    /*gap: 17px;*/\n\n    position: relative;\n    height: 100%;\n    overflow: hidden;\n}\n\n.meetingPage_video{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    /*gap: 19px;*/\n    height: 100%;\n    padding: 16px 9px;\n}\n\n.meetingPage_chat{\n    width: 100%;\n    --gap: 40px;\n    gap: var(--gap);\n    display: flex;\n    /*flex-direction: column;*/\n    /*align-items: center;*/\n\n    flex-wrap: wrap;\n    --cols: 1;\n}\n\n.meetingPage_bottom{\n    display: flex;\n    padding: 22px 0px;\n    gap: 17px;\n}\n\n.meetingPage_wordTimes{\n    display: flex;\n    align-items: flex-start;\n}\n\n.meetingPage_widgets{\n    overflow-x: hidden;\n    overflow-y: auto;\n    /*width: 320px;*/\n    flex-shrink: 0;\n    height: 100%;\n    padding: 16px 9px;\n    scrollbar-width: thin; /* Firefox */\n    scrollbar-color: transparent transparent; /* Firefox */\n}\n\n.meetingPage_widgets::-webkit-scrollbar {\n    width: 8px;\n}\n\n.meetingPage_widgets::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 4px;\n    margin: 4px 0;\n}\n\n.meetingPage_widgets::-webkit-scrollbar-thumb {\n    background: transparent;\n    border-radius: 4px;\n    transition: background-color 0.3s ease;\n}\n\n.meetingPage_widgets:hover {\n    scrollbar-color: rgba(193, 193, 193, 0.8) rgba(241, 241, 241, 0.8); /* Firefox */\n}\n\n.meetingPage_widgets:hover::-webkit-scrollbar-track {\n    background: rgba(241, 241, 241, 0.8);\n}\n\n.meetingPage_widgets:hover::-webkit-scrollbar-thumb {\n    background: rgba(193, 193, 193, 0.8);\n}\n\n.meetingPage_widgets:hover::-webkit-scrollbar-thumb:hover {\n    background: rgba(168, 168, 168, 0.9);\n}\n\n/*collapser*/\n.meetingPage_video_collapser{\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: flex-end;\n    transition-duration: 400ms;\n    transition-delay: 0ms;\n    --phaseDelay: 400ms;\n}\n\n.meetingPage_video{\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    transition-duration: 400ms;\n    transition-delay: var(--phaseDelay);\n    left: 0%;\n}\n\n.meetingPage_video_collapser--collapsed{\n    width: 60px;\n    transition-delay: var(--phaseDelay);\n    overflow: hidden;\n    flex-shrink: 0;\n}\n\n.meetingPage_video_collapser--collapsed .meetingPage_video{\n    left: calc(-100% - 10px);\n    transition-delay: 0ms;\n}\n\n.meetingPage_widgets{\n    --phaseDelay: 400ms;\n    transition-duration: 400ms;\n    /*transition-delay: calc(var(--phaseDelay));*/\n}\n\n.meetingPage_widgets--collapsed{\n    flex-shrink: 1;\n    width: 100%;\n    transition-delay: 0ms;\n    transition-delay: calc(var(--phaseDelay));\n}\n\n.meetingPage_video_collapser_hold_zero{\n    flex-shrink: 0;\n    position: absolute;\n    left: 100%;\n    height: 100%;\n    overflow: hidden;\n    width: 0px;\n    transition: left 400ms, width 50ms;\n    /*transition-delay: calc(var(--phaseDelay));*/\n    display: flex;\n    justify-content: flex-end;\n    flex-shrink: 0;\n}\n.meetingPage_video_collapser_hold{\n    position: absolute;\n    left: 100%;\n    overflow: hidden;\n    width: 60px;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    padding: 16px 9px;\n}\n\n.meetingPage_video_collapse_button{\n    position: absolute;\n    right: 6px;\n    background-color: #fff;\n    width: 18px;\n    height: 18px;\n    border: 1px solid #ddd;\n    border-radius: 100%;\n    z-index: 1;\n    font-size: 0;\n\n    background-image: url('../../assets/chevron-right.svg');\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.meetingPage_video_collapse_button_right{\n    right: unset;\n    background-image: url('../../assets/chevron-left.svg');\n}\n\n.meetingPage_video_collapser--collapsed .meetingPage_video_collapser_hold{\n    left: 0px;\n}\n\n.meetingPage_video_collapser--collapsed .meetingPage_video_collapser_hold_zero{\n    width: 60px;\n    left: 0;\n}\n/**/\n\n.meetingPage_video_subtitles_splitter{\n    cursor: ns-resize;\n    user-select: none; \n    font-size: 0;\n    flex-shrink: 0;\n    height: 19px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.meetingPage_video_subtitles_splitter::before {\n    content: '';\n    width: 48px;\n    height: 2px;\n    background-color: #d4d4d8;\n    border-radius: 1px;\n    transition: background-color 0.2s ease;\n}\n\n.meetingPage_video_subtitles_splitter:hover::before {\n    background-color: #a1a1aa;\n}\n\n.meetingPage_bottom_graphic{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    width: calc((100% - (var(--gap) * (var(--cols) - 1))) / var(--cols));\n}\n\n/*collapser new*/\n\n.meetingPage_TwoColumnCollapser_wrapper{\n\n}\n\n.meetingPage_TwoColumnCollapser_wrapper--both .meetingPage_TwoColumnCollapser_right{\n    flex-shrink: 0;\n    width: 350px;\n}\n\n.meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_TwoColumnCollapser_right{\n    flex-shrink: 1;\n    width: 100%;\n}\n\n.meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_chat{\n    --cols: 3;\n    padding-top: 10px;\n    transition-delay: 400ms;\n    transition-duration: 200ms;\n}\n\n@media (max-width: 1080px){\n    .meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_chat{\n        --cols: 2;\n    }\n}\n\n@media (max-width: 700px){\n    .meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_chat{\n        --cols: 1;\n    }\n}\n\n.meetingPage_TwoColumnCollapser_wrapper--right .meetingPage_bottom_graphic{\n    transition-delay: 400ms;\n    transition-duration: 200ms;\n}\n\n.meetingPage_TwoColumnButtons{\n    display: flex;\n    padding: 2px 8px;\n    gap: 8px;\n    position: absolute;\n    top: -2px;\n    z-index: 1;\n    border-radius: 8px;\n    background-color: #fff;\n}\n\n.meetingPage_TwoColumnButton{\n    border-radius: 100%;\n    width: 28px;\n    height: 28px;\n    border: none;\n\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    font-size: 0;\n}\n\n.meetingPage_TwoColumnButton:hover {\n    background-color: #0001;\n}\n\n.meetingPage_TwoColumnButton--active {\n    background-color: #0002;\n}\n\n.meetingPage_TwoColumnButton_left{\n    background-image: url('../../assets/collapser/left.png');\n}\n\n.meetingPage_TwoColumnButton_right{\n    background-image: url('../../assets/collapser/right.png');\n}\n\n.meetingPage_TwoColumnButton_both{\n    background-image: url('../../assets/collapser/both.png');\n}\n\n/**/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
